module.exports = __webpack_public_path__ + "static/media/Logowhite.92415869.png";